/* eslint-disable */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

export default class JobInfo extends Component {
    getNumberOfConfirmedBookings = bookings => {
        if (bookings) {
            return bookings.filter(e => e.date_accepted).length;
        }
        return 0;
    };

    render() {
        const convertDateTime = datetime =>
            moment(new Date(datetime), 'HH:mm:ss').format('hh:mm A');
        const startDateTime = convertDateTime(this.props.job.start_datetime);
        const endDateTime = convertDateTime(this.props.job.end_datetime);
        const startToEndDateTime = `${startDateTime} - ${endDateTime}`;
        const freelancerPerHour = `£${this.props.job.freelancer_pay_per_hour}/h`;
        const clientPerHour = `£${this.props.job.client_pay_per_hour}/h`;
        const numberOfApplicationsAccepted = this.getNumberOfConfirmedBookings(
            this.props.applications,
        );
        const matched = `${numberOfApplicationsAccepted}/${this.props.job.number_of_freelancers}`;
        const completed =
            (numberOfApplicationsAccepted /
                this.props.job.number_of_freelancers) *
            100;
        return (
            <div className="job-info">
                <div className="job-info-left">
                    <div className="job-info-field">
                        <div className="job-info-label">Client pay</div>
                        <div className="job-info-value">{clientPerHour}</div>
                    </div>
                    <div className="job-info-field">
                        <div className="job-info-label">Freelancer pay</div>
                        <div className="job-info-value">
                            {freelancerPerHour}
                        </div>
                    </div>
                    <div className="job-info-field">
                        <div className="job-info-label">Matched</div>
                        <div className="job-info-value">
                            <div className="job-info-progress" />
                            {matched}
                        </div>
                    </div>
                </div>
                <div className="job-info-right">
                    <div className="job-info-field">
                        <div className="job-info-label">Address</div>
                        <div className="job-info-value">
                            {this.props.job.address1}
                        </div>
                    </div>
                    <div className="job-info-field">
                        <div className="job-info-label">Postcode</div>
                        <div className="job-info-value">
                            {this.props.job.postcode}
                        </div>
                    </div>
                    <div className="job-info-field">
                        <div className="job-info-label">Date</div>
                        <div className="job-info-value">
                            {this.props.job.date}
                        </div>
                    </div>
                    <div className="job-info-field">
                        <div className="job-info-label" />
                        <div className="job-info-value">
                            {startToEndDateTime}
                        </div>
                    </div>
                </div>
                <div className="job-info-clear" />
            </div>
        );
    }
}
